import * as _ from "lodash";
import * as angular from "angular";

let DateRangeComponent = {
    selector: "vcDateRange",
    templateUrl: "/angular/components/event/dates/date-range.component.html",
    bindings: {
        start: "=?",
        end: "=?",
        sectionHeader: "=?",
        noEnd: "=?",
    },
    controller: class DateRangeController {
        // * bindings for typescript compiler *
        public start?: any;
        public end?: any;
        public sectionHeader?: boolean = true;
        public noEnd?: boolean = false;
        public dateLocale: any = false;
        public $filter: any;
        private preferencesService: any;
        // ************************************

        private use24hr: boolean = false;
        public periods: string[];
        public hours: number[];
        public readonly minutes = ["00", 15, 30, 45];
        public readonly days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ];

        public minStartDate: Date;
        public minEndDate: any;

        constructor($filter: any, PreferencesService: any) {
            this.$filter = $filter;
            this.preferencesService = PreferencesService;
            this.use24hr = PreferencesService.use24Hour();
            this.periods = this.use24hr ? [""] : ["am", "pm"];
            this.hours = this.use24hr
                ? [
                      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                      17, 18, 19, 20, 21, 22, 23,
                  ]
                : [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
            this.minStartDate = new Date();
            this.dateLocale = {
                formatDate: (date: string) => {
                    let dateObj: Date = new Date(date);

                    if (dateObj.getFullYear() > 1971) {
                        return this.$filter("date")(dateObj, "MMM dd, yyyy");
                    }
                    return null;
                },
            };
        }

        $onInit() {
            if (this.start) {
                this.timeChanged(
                    this.start,
                    this.start.time.period,
                    this.start.time.hours,
                    this.start.time.minutes
                );
                if (this.start.date < new Date())
                    this.minStartDate = _.cloneDeep(this.start.date);
            }

            if (this.end) {
                this.timeChanged(
                    this.end,
                    this.end.time.period,
                    this.end.time.hours,
                    this.end.time.minutes
                );
            }

            this.minEndDate = _.cloneDeep(this.start.date);
        }

        formatTimeOption(hour: number, minute: any, period: string): string {
            if (this.use24hr) {
                const h = hour < 10 ? "0" + hour : hour.toString();
                return h + ":" + minute;
            }
            return hour + ":" + minute + period;
        }

        timeChanged(
            obj: any,
            period: string,
            hour: number,
            minute: number,
            ignorePeriod?: boolean,
            autoSwitch?: boolean
        ): void {
            if (this.use24hr) {
                obj.date.setHours(hour, minute, 0, 0);
                obj.time.hours = hour;
                obj.time.minutes = minute;
                obj.time.period = "";
                obj.time.model = this.formatTimeOption(hour, minute, "");
            } else {
                if (!ignorePeriod) {
                    if (hour === 12) {
                        hour = 0;
                    }
                    if (period === "pm" && hour < 13) {
                        hour = hour + 12;
                    }
                }

                obj.date.setHours(hour, minute, 0, 0);

                if (period === "pm" && hour > 12) {
                    hour = hour - 12;
                }
                obj.time.hours = hour;
                obj.time.minutes = minute;
                obj.time.period = period;
            }

            if (autoSwitch) {
                this.autoSwitchTime();
            }
        }

        autoSwitchTime(): void {
            if (!this.end?.time) {
                return;
            }

            if (
                !this.isTimeAllowed(
                    this.end.time.period,
                    this.end.time.hours,
                    this.end.time.minutes
                )
            ) {
                this.end.time = _.cloneDeep(this.start.time);

                if (this.use24hr) {
                    this.end.time.hours += 1;
                    if (this.end.time.hours >= 24) {
                        this.end.time.hours = 0;
                        let newDate = new Date(
                            this.end.date.setDate(this.end.date.getDate() + 1)
                        );
                        this.end.date = _.cloneDeep(newDate);
                    }
                    this.end.time.model = this.formatTimeOption(
                        this.end.time.hours,
                        this.end.time.minutes,
                        ""
                    );
                    this.end.date.setHours(
                        this.end.time.hours,
                        this.end.time.minutes,
                        0,
                        0
                    );
                } else if (
                    this.end.time.hours == 11 &&
                    this.end.time.period == "am"
                ) {
                    this.end.time.period = "pm";
                    this.end.time.hours += 1;
                    this.end.time.model =
                        this.end.time.hours +
                        ":" +
                        this.end.time.minutes +
                        this.end.time.period;
                    this.end.date.setHours(
                        this.end.time.hours,
                        this.end.time.minutes,
                        0,
                        0
                    );
                } else {
                    this.end.time.hours += 1;
                    if (this.end.time.period == "pm") {
                        if (this.end.time.hours == 24) {
                            this.end.time.hours = 12;
                            this.end.time.period = "am";
                            let newDate = new Date(
                                this.end.date.setDate(
                                    this.end.date.getDate() + 1
                                )
                            );
                            this.end.date = _.cloneDeep(newDate);
                            this.end.time.model =
                                this.end.time.hours +
                                ":" +
                                this.end.time.minutes +
                                this.end.time.period;
                            this.end.date.setHours(
                                0,
                                this.end.time.minutes,
                                0,
                                0
                            );
                        } else {
                            this.end.time.model =
                                this.end.time.hours -
                                12 +
                                ":" +
                                this.end.time.minutes +
                                this.end.time.period;
                            this.timeChanged(
                                this.end,
                                this.end.time.period,
                                this.end.time.hours,
                                this.end.time.minutes,
                                true,
                                false
                            );
                        }
                    } else {
                        this.end.time.model =
                            this.end.time.hours +
                            ":" +
                            this.end.time.minutes +
                            this.end.time.period;
                        this.timeChanged(
                            this.end,
                            this.end.time.period,
                            this.end.time.hours,
                            this.end.time.minutes,
                            true,
                            false
                        );
                    }
                }
            }
        }

        isTimeAllowed(period: string, hours: number, minutes: number): boolean {
            let end = _.cloneDeep(this.end);
            let start = _.cloneDeep(this.start);

            if (
                end &&
                end.date &&
                end.date.getFullYear &&
                start &&
                start.date &&
                start.date.getFullYear
            ) {
                if (
                    end.date.getFullYear() === start.date.getFullYear() &&
                    end.date.getMonth() === start.date.getMonth() &&
                    end.date.getDate() === start.date.getDate()
                ) {
                    if (this.use24hr) {
                        let startHours = start.time.hours;
                        return (
                            hours > startHours ||
                            (hours === startHours &&
                                minutes > start.time.minutes)
                        );
                    }

                    if (hours == 12) hours = 0;
                    if (start.time.hours == 12) start.time.hours = 0;

                    if (period === "pm" && hours < 13) {
                        hours += 12;
                    }

                    if (start.time.period === "pm" && start.time.hours < 13) {
                        start.time.hours += 12;
                    }

                    return (
                        hours > start.time.hours ||
                        (hours === start.time.hours &&
                            minutes > start.time.minutes)
                    );
                } else {
                    return true;
                }
            }
        }

        dateChanged(): void {
            if (!!this.start && !!this.end && this.start.date > this.end.date) {
                this.end.date = _.cloneDeep(this.start.date);
                this.timeChanged(
                    this.start,
                    this.start.time.period,
                    this.start.time.hours,
                    this.start.time.minutes,
                    true,
                    true
                );
                this.timeChanged(
                    this.end,
                    this.end.time.period,
                    this.end.time.hours,
                    this.end.time.minutes,
                    true,
                    true
                );
            }

            this.minEndDate = _.cloneDeep(this.start.date);
        }
    },
};

angular
    .module("event")
    .component(DateRangeComponent.selector, DateRangeComponent);
